import { useMemo } from 'react'
import { usePDFStore } from '../../../../stores/pdf.store'
import { useSigningForm } from '../Provider'
import { SigningFormFieldPlaceholder } from './Placeholder'
import { SigningFormFieldSwitcher, buildSigningFieldPath } from './Switcher'

export const SigningFormFieldsList = () => {
  const focusedBlock = usePDFStore((state) => state.focusedBlock)

  const fields = usePDFStore((state) => state.fields)

  const form = useSigningForm()

  return (
    <div>
      {form.filteredFields.map((field, index) => (
        <SigningFormFieldPlaceholder key={field.id} field={field}>
          <SigningFormFieldSwitcher
            key={field.id}
            field={field}
            index={index}
          />
        </SigningFormFieldPlaceholder>
      ))}
    </div>
  )
}
